import { DisplayCardIcon } from '@aon/aon-tws-common-ui';
import React from 'react';

type AdminCardProps = { onClick?: () => void; headline: string; hide?: boolean; disabled?: boolean; attrKey?: number };

export const AdminCard = (props: AdminCardProps) => {
	const disabled = props.disabled === undefined ? true : props.disabled;
	return props.hide ? null : (
		<DisplayCardIcon key={props.attrKey} text={props.headline} textSize={'sm'} onClick={props.onClick} disabled={disabled} />
	);
};
